
/**
 * Utility functions for handling form submissions
 */

/**
 * Opens an email client with pre-populated fields
 * @param recipientEmail The email address to send to
 * @param subject The email subject
 * @param body The email body content
 * @returns void
 */
export const openEmailClient = (
  recipientEmail: string,
  subject: string,
  body: string
): void => {
  const encodedSubject = encodeURIComponent(subject);
  const encodedBody = encodeURIComponent(body);
  
  const mailtoLink = `mailto:${recipientEmail}?subject=${encodedSubject}&body=${encodedBody}`;
  
  // Try to open the email client
  try {
    window.location.href = mailtoLink;
  } catch (error) {
    console.error('Error opening email client:', error);
    // Fallback: try opening in a new window
    window.open(mailtoLink, '_blank');
  }
};
